<template>
  <v-dialog v-model="dialog" persistent max-width="420">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>{{ text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="color || 'error'" @click="submit">
          <v-icon v-if="icon">{{ icon }}</v-icon>
          {{ confirmText }}
        </v-btn>
        <v-btn color="secondary" outline @click="close">{{ cancelText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
      text: {
        type: String,
        required: true,
      },
      confirmText: {
        type: String,
        required: true,
      },
      cancelText: {
        type: String,
        default: 'Cancel',
      },
      color: {
        type: String,
        required: true,
      },
      icon: String,
    },
    data() {
      return {
        dialog: false,
      }
    },
    methods: {
      close() {
        this.dialog = false
      },
      submit() {
        this.$emit('submit')
        this.close()
      },
      show() {
        this.dialog = true
      },
    },
  }
</script>